import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  label: 'Add another item on Save',
})
